var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrustpilotStar = function SvgTrustpilotStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": "starRating"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "trustpilotStar_svg__tp-star"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 46.33h46.376V0H0v46.33z",
    fill: "#00b67a",
    className: "trustpilotStar_svg__tp-star__canvas"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M39.534 19.711 13.23 38.801l3.838-11.798L7.021 19.71h12.42l3.837-11.798 3.837 11.798h12.419v.001zm-16.255 11.8L30.462 30l2.862 8.8-10.045-7.29v.001z",
    className: "trustpilotStar_svg__tp-star__shape"
  }))));
};
export default SvgTrustpilotStar;